import { schemes, zSchema } from "@zeal/common";

export const getEmployeeCheckIDsRequestSchema = zSchema.object({
  end_date: schemes.isoDate(),
  start_date: schemes.isoDate(),
});

export type TGetEmployeeCheckIDsRequestSchema = zSchema.input<
  typeof getEmployeeCheckIDsRequestSchema
>;

export const getEmployeeCheckIDsResponseSchema = zSchema.array(
  zSchema.string()
);

export type TGetEmployeeCheckIDsResponseSchema = zSchema.infer<
  typeof getEmployeeCheckIDsResponseSchema
>;
